import { finalizeDraft } from '@/sdk/clients/ServicesRequest'

export default {
  async finalizeDraft({ commit, rootState, dispatch }) {
    const draftUuid = rootState.registration.serviceRequestDraftId

    await finalizeDraft(draftUuid)

    commit('registration/setServiceRequestDraftId', '', { root: true })

    dispatch('registration/removeSRDraftDataFromLocalStorage', null, {
      root: true,
    })
  },
}
